import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ConfigApi } from "../../config-api";
import { ApiCallingService } from "../../services/api-calling.service";

@Component({
  selector: "app-user-membership-detail",
  templateUrl: "./user-membership-detail.component.html",
  styleUrls: ["./user-membership-detail.component.css"],
})
export class UserMembershipDetailComponent implements OnInit {
  membershipId: string;
  details: any;

  constructor(
    private apiCallingService: ApiCallingService,
    private route: ActivatedRoute
  ) {
    this.membershipId = this.route.snapshot.paramMap.get("id") || "";
  }

  ngOnInit(): void {
    this.getMembershipDetails();
  }

  getMembershipDetails() {
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.MEMBERSHIP.USER_MEMBERSHIP_DETAILS +
          "/" +
          this.membershipId
      )
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.details = res.data;
        }
      });
  }
}
